import { datadogRum } from "@datadog/browser-rum";
import { getEnvironmentFromURL, hasWindow } from "../utils";
export var initDataDogRUM = function(param) {
    var service = param.serviceName, sampleRate = param.rumGlobalSampleRate, applicationId = param.applicationId, clientToken = param.datadogRumClientToken, version = param.appVersion;
    if (hasWindow) {
        var env = getEnvironmentFromURL(window.location.hostname);
        datadogRum.init({
            applicationId: applicationId,
            clientToken: clientToken,
            sampleRate: sampleRate,
            env: env,
            trackInteractions: true,
            trackFrustrations: true,
            service: service,
            site: "datadoghq.eu",
            version: version,
            silentMultipleInit: true,
            allowedTracingOrigins: [
                "https://api-dev.cinch.co.uk",
                "https://api-production.cinch.co.uk",
                /https:\/\/.*\.snc-(dev|prod)\.aws\.cinch\.co\.uk/, 
            ]
        });
        datadogRum.startSessionReplayRecording();
    }
};
